import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'progress-loader',
  styleUrls: ['./progress-loader.component.scss'],
  templateUrl: './progress-loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressLoaderComponent implements AfterViewInit, OnChanges {
  @Input() public height: number = 32;
  @Input() public width: number = 32;
  @Input() public value: number = 0;
  @Input() public strokeWidth: number = 3;
  public radius: number;
  public circumference: number;
  public strokeDashoffset: number;

  constructor(private el: ElementRef, private cdr: ChangeDetectorRef) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      this.updateProgress(changes.value.currentValue);
    }
  }

  public ngAfterViewInit(): void {
    this.radius = (this.height / 2) - (this.strokeWidth / 2);
    this.circumference = 2 * Math.PI * this.radius;
    this.updateProgress(this.value);
    this.cdr.detectChanges();
  }

  public updateProgress(value: number): void {
    const progress = value / 100;
    const dashoffset = this.circumference * (1 - progress);
    this.strokeDashoffset = dashoffset;
  }
}
